"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import DefaultFieldValue from './Default.mjs';

function ArrayFieldValue({
  field,
  onChange,
  refsToIgnoreClick,
  topDropdownPanelComponent
}) {
  if (Array.isArray(field.value) && field.value.length > 0 && field.schema?.items) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    DefaultFieldValue,
    {
      field,
      onChange,
      refsToIgnoreClick,
      topDropdownPanelComponent
    }
  );
}

export { ArrayFieldValue as default };
